export default __webpack_public_path__ + "static/media/Union (5).ada1f34a.svg";